import React from "react";
import cn from "classnames";
import { resolveSlug } from "../../../lib/utils/resolveSlug";
import StoryblokImage from "../../../components/StoryblokImage";
import Image from "next/image";
import fallbackImage from "../../../public/images/tobii-seo-fallback.jpg";
import { imageSizes } from "../../../lib/utils/imageUtils";
import s from "../RelatedContent.module.scss";
import { StoryCardProps } from "../../../lib/storyblok/types/blocks/RelatedContentBlock";
import { useTranslation } from "next-i18next";
import BlockIntro from "../../Common/BlockIntro";
import BlockBackground from "../../Common/BlockBackground";

const StoryCard: React.FC<StoryCardProps> = ({
  story,
  slim,
  showContent,
  showLabel,
  overlay,
}) => {
  const { t } = useTranslation("searchpage");
  const slug = resolveSlug(story.fullSlug);
  const label = t(`pages.${story.storyType}`);

  return (
    <a
      href={slug}
      title={story.title}
      className={cn(s.storyCard, { [s.slim]: slim, [s.overlay]: overlay })}
    >
      <div className={s.imageContainer}>
        {story.image ? (
          <StoryblokImage
            image={story.image}
            resize={{ width: 720 }}
            sizes={imageSizes("100vw", {
              desktop: "720px",
            })}
            layout="fill"
            alt={story.title}
            priority={false}
          />
        ) : (
          <Image
            src={fallbackImage}
            sizes={slim ? imageSizes("480px") : imageSizes("720px")}
            layout="fill"
            alt={story.title}
            priority={false}
          />
        )}
      </div>

      <div className={s.storyDetails}>
        {overlay && (
          <div className={s.contentBackground}>
            <BlockBackground style={"black"} opacity={100} />
          </div>
        )}
        <BlockIntro
          alignment={overlay ? "alignCenter" : "alignLeft"}
          inverted={overlay ? true : false}
          title={story.title}
          description={showContent ? story.metaDescription : null}
          label={showLabel ? label : null}
          width={"full"}
          descriptionSize={"small"}
          descriptionStyle={"faded"}
          headingTag={slim ? "h5" : "h4"}
        />
      </div>
    </a>
  );
};

export default StoryCard;
